import { gql } from '@apollo/client';

const monthsMapper = [
  [0, 1, 2],
  [3, 4, 5],
  [6, 7, 8],
  [9, 10, 11],
];

export interface IScoreVariables {
  year: number;
  quarter: number;
}

export const getScoreEntitiesVariables: () => IScoreVariables = () => {
  const curDate = new Date();
  const month = curDate.getMonth();
  const curYear = curDate.getFullYear();
  const curQuarter = monthsMapper.findIndex((el) => el.includes(month)) + 1;
  const isFirstYearQuarter = curQuarter === 1;

  const quarter = Math.floor((month + 3) / 3);
  const year = isFirstYearQuarter ? curYear - 1 : curYear;

  return { year, quarter };
};

export const getScoresEntities = gql`
  query GetScoreEntitiesForQuarterAndYear($year: Int!, $quarter: Int!) {
    scoreEntitiesForQuarterAndYear(year: $year, quarter: $quarter) {
      id
      name
      supplierKrn
      externalIdentifier
      quarter
      year
      scores {
        name
        orderValue
        rating
        scoreCategory
      }
    }
  }
`;
